export default {
  "menu.welcome": "歡迎",
  "menu.more-blocks": "更多區塊",
  "menu.home": "首頁",
  "menu.portalV2.workbench": "工作臺",
  "menu.portalV2.collaboration": "研發協同",
  "menu.portalV2.delivery": "交付中心",
  "menu.portalV2.deliveryEfficiency": "交付效能",
  "menu.portalV2.engineeringEfficiency": "工程效能",
  "menu.portalV2.feedback": "反饋管理",
  "menu.portalV2.releaseWorkbench": "發布工作臺",
  "menu.portalV2.releaseCalendar": "發布日曆",
  "menu.portalV2.releaseAnalytics": "發布分析",
  "menu.portalV2.serviceView": "服務檢視",
  "menu.portalV2.releaseRecord": "發布記錄",
  "menu.portalV2.rollbackRecord": "回滾記錄",
  "menu.portalV2.operations": "生產保障",
  "menu.portalV2.insights": "效能洞察",
  "menu.portalV2.managementCockpit": "效能中心",
  "menu.portalV2.organization": "產研組織",
  "menu.portalV2.qualityInsights": "質量洞察",
  "menu.portalV2.administration": "平臺管理",
  "menu.admin": "管理",
  "menu.admin.sub-page": "子頁面",
  "menu.login": "登入",
  "menu.register": "註冊",
  "menu.register-result": "註冊結果",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.dashboard": "Dashboard",
  "menu.dashboard.analysis": "分析頁",
  "menu.dashboard.monitor": "監控頁",
  "menu.form": "表單頁",
  "menu.form.basic-form": "基礎表單",
  "menu.form.step-form": "分步表單",
  "menu.form.step-form.info": "分步表單（填寫轉賬資訊）",
  "menu.form.step-form.confirm": "分步表單（確認轉賬資訊）",
  "menu.form.step-form.result": "分步表單（完成）",
  "menu.form.advanced-form": "高階表單",
  "menu.list": "列表頁",
  "menu.list.table-list": "查詢表格",
  "menu.list.basic-list": "標準列表",
  "menu.list.card-list": "卡片列表",
  "menu.list.search-list": "搜尋列表",
  "menu.list.search-list.articles": "搜尋列表（文章）",
  "menu.list.search-list.projects": "搜尋列表（專案）",
  "menu.list.search-list.systems": "搜尋列表（系統）",
  "menu.list.search-list.applications": "搜尋列表（應用）",
  "menu.profile": "詳情頁",
  "menu.profile.basic": "基礎詳情頁",
  "menu.profile.advanced": "高階詳情頁",
  "menu.result": "結果頁",
  "menu.result.success": "成功頁",
  "menu.result.fail": "失敗頁",
  "menu.exception": "異常頁",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "觸發錯誤",
  "menu.account": "個人頁",
  "menu.account.center": "個人中心",
  "menu.account.settings": "個人設定",
  "menu.account.trigger": "觸發報錯",
  "menu.account.logout": "退出登入",
  "menu.editor": "圖形編輯器",
  "menu.editor.flow": "流程編輯器",
  "menu.editor.mind": "腦圖編輯器",
  "menu.editor.koni": "拓撲編輯器",
  "menu.workplace": "工作臺",
  "menu.workplace.myWorkplace": "我的工作臺",
  "menu.workplace.myTaskDetails": "我的資料透視",
  "menu.workplace.departmentTaskDetails": "團隊資料透視",
  "menu.workplace.businessDataReport": "業務領域資料包表",
  "menu.workplace.improveDashboard": "業務領域改進看板",
  "menu.workplace.roleImproveDashboard": "專業線改進看板",
  "menu.workplace.userImproveDashboard": "人員改進看板",
  "menu.workplace.myImproveDashboard": "我的改進看板",
  "menu.workplace.myLikeCard": "我的點贊卡",
  "menu.workplace.teamGanttChart": "全員甘特圖",
  "menu.workplace.personalGanttChart": "個人甘特圖",
  "menu.dashboard.dataDashboard": "產研大盤",
  "menu.dashboard.dataDashboard.productData": "需求交付",
  "menu.dashboard.dataDashboard.country": "國家大盤",
  "menu.dashboard.dataDashboard.industryLine": "行業線大盤",
  "menu.dashboard.dataDashboard.professionalLineData": "研發任務",
  "menu.dashboard.dataDashboard.personalGanttChart": "個人甘特圖",
  "menu.dashboard.dataDashboard.teamGanttChart": "全員甘特圖",
  "menu.dashboard.issue": "需求儀表盤",
  "menu.dashboard.pool": "自定義需求池",
  "menu.dashboard.organization": "產研組織",
  "menu.dashboard.organization.weekly": "每週三省吾身",
  "menu.dashboard.organization.weekly.send": "我發出的",
  "menu.dashboard.organization.weekly.receive": "我收到的",
  "menu.dashboard.organization.weekly.all": "全部",
  "menu.dashboard.organization.weekly.department": "部門週報",
  "menu.dashboard.organization.weekly.role": "產品週報",
  "menu.dashboard.organization.weekly.project": "專案週報",
  "menu.dashboard.organization.duty": "值班表",
  "menu.dashboard.organization.team": "人員分佈",
  "menu.dashboard.organization.team.structure": "組織架構",
  "menu.dashboard.organization.team.structure.rd": "研發中心",
  "menu.dashboard.organization.team.structure.operation": "產品運營",
  "menu.dashboard.organization.team.assignment": "人員配置",
  "menu.projectSet": "專案管理",
  "menu.projectSet.spaceManagement": "空間列表",
  "menu.projectSet.projectManagement": "專案列表",
  "menu.projectSet.projectRelated": "我相關的",
  "menu.projectSet.projectResponsible": "我負責的",
  "menu.projectSet.projectFavorites": "我收藏的",
  "menu.projectSet.projectViewable": "我能看的",
  "menu.projectSet.projectManagement.projectRelated": "我相關的",
  "menu.projectSet.projectManagement.projectResponsible": "我負責的",
  "menu.projectSet.projectManagement.projectFavorites": "我收藏的",
  "menu.projectSet.projectManagement.projectViewable": "我能看的",
  "menu.rd": "研發協同",
  "menu.rd.businessIssue": "業務需求",
  "menu.rd.productIssue": "產品需求",
  "menu.rd.productIssueCreate": "建立編輯",
  "menu.rd.issueSearch": "需求搜尋",
  "menu.rd.sprint": "迭代規劃",
  "menu.rd.detail": "詳情",
  "menu.rd.planning": "規劃",
  "menu.rd.issues.poolShareDetail": "需求預覽",
  "menu.rd.review": "會議中心",
  "menu.rd.issues": "需求",
  "menu.rd.tasks": "任務中心",
  "menu.rd.test": "質量管理",
  "menu.rd.test.case": "測試用例",
  "menu.rd.test.minder": "用例詳情",
  "menu.rd.test.bug": "測試缺陷",
  "menu.rd.test.testBugCharts": "研發過程質量",
  "menu.rd.deliveryQuality": "交付質量",
  "menu.rd.deliveryQuality.reBug": "迴歸缺陷",
  "menu.rd.deliveryQuality.onlineBugs": "線上問題",
  "menu.rd.deliveryQuality.businessAcceptance": "業務驗收",
  "menu.rd.deliveryQuality.productAcceptance": "產品驗收",
  "menu.rd.deliveryQuality.incidentResponse": "事件響應",
  "menu.rd.deliveryQuality.accidentReportCreate": "新建",
  "menu.rd.plan": "規劃",
  "menu.rd.statistics": "統計",
  "menu.feedback": "反饋管理",
  "menu.feedback.board": "反饋看板",
  "menu.feedback.detail": "反饋詳情",
  "menu.feedback.config": "配置管理",
  "menu.chat": "NextChat",
  "menu.chat.gemini": "Gemini Pro",
  "menu.chat.qwenPlus": "Qwen Plus",
  "menu.test": "測試管理",
  "menu.test.case": "測試用例",
  "menu.test.minder": "用例詳情",
  "menu.test.report": "測試報告",
  "menu.rd.test.bugCreate": "建立缺陷",
  "menu.rd.test.bugEdit": "編輯缺陷",
  "menu.rd.onlineBugCreate": "建立",
  "menu.rd.onlineBugEdit": "編輯",
  "menu.rd.deliveryQuality.reBugCreate": "建立",
  "menu.rd.deliveryQuality.reBugEdit": "編輯",
  "menu.delivery": "釋出看板",
  "menu.delivery.view": "交付檢視",
  "menu.delivery.services": "服務檢視",
  "menu.delivery.record": "釋出記錄",
  "menu.delivery.ci": "持續整合",
  "menu.delivery.ci.release": "交付檢視",
  "menu.delivery.ci.services": "服務檢視",
  "menu.delivery.ci.record": "釋出記錄",
  "menu.delivery.cd": "持續交付",
  "menu.delivery.cd.release": "交付檢視",
  "menu.delivery.cd.services": "服務檢視",
  "menu.delivery.cd.record": "釋出記錄",
  "menu.delivery.rollback": "復原記錄",
  "menu.delivery.gray": "灰度釋出",
  "menu.delivery.gray.view": "灰度觀測",
  "menu.delivery.gray.graySetting": "前端灰度配置",
  "menu.delivery.gray.backendGraySetting": "後端灰度配置",
  "menu.delivery.appointment": "釋出日曆",
  "menu.delivery.k8s": "K8s叢集",
  "menu.delivery.service": "服務詳情",
  "menu.delivery.revision": "版本詳情",
  "menu.dashboard.efficiency": "效能洞察",
  "menu.dashboard.efficiency.dashboard": "需求交付概覽",
  "menu.dashboard.efficiency.dashboard.dashboard": "需求交付概覽",
  "menu.dashboard.efficiency.dashboard.requirementDashboard": "需求資料看板",
  "menu.dashboard.efficiency.dashboard.businessDashboard": "業務需求看板",
  "menu.dashboard.efficiency.workplace": "交付效率看板",
  "menu.dashboard.efficiency.cost": "成本透視",
  "menu.dashboard.efficiency.issueAndBug": "需求缺陷明細",
  "menu.dashboard.efficiency.monthlyReport": "月度報告",
  "menu.dashboard.efficiency.scanner": "程式碼質量",
  "menu.dashboard.efficiency.quality": "質量洞察看板",
  "menu.dashboard.efficiency.quality.testBugCharts": "研發過程質量",
  "menu.dashboard.efficiency.quality.bugProcess": "Bug日清",
  "menu.dashboard.efficiency.quality.onlineBugProcess": "線上問題日清",
  "menu.dashboard.efficiency.quality.onlineBugCharts": "線上交付質量",
  "menu.dashboard.efficiency.service": "交付能力洞察",
  "menu.dashboard.efficiency.service.serviceStatistics": "釋出概覽",
  "menu.dashboard.efficiency.service.serviceEmergencyStatistics": "緊急釋出概覽",
  "menu.dashboard.efficiency.service.serviceCntBar": "釋出趨勢",
  "menu.dashboard.efficiency.metric": "效能指標",
  "menu.dashboard.efficiency.metric.personalDashboard": "個人看板",
  "menu.dashboard.efficiency.metric.teamDashboard": "團隊看板",
  "menu.dashboard.efficiency.metric.teamComparison": "團隊對比",
  "menu.dashboard.efficiency.metric.businessDashboard": "業務看板",
  "menu.dashboard.efficiency.metric.summaryDashboard": "彙總看板",
  "menu.dashboard.efficiency.performance": "效能度量評分",
  "menu.dashboard.efficiency.performance.business": "效能度量評分",
  "menu.dashboard.efficiency.performance.personal": "效能度量員工評分",
  "menu.dashboard.efficiency.scanner.sonar": "靜態掃描",
  "menu.dashboard.efficiency.scanner.openSCA": "程式碼風險",
  "menu.dashboard.efficiency.model": "效能評分模型",
  "menu.dashboard.efficiency.health": "健康度指標",
  "menu.dashboard.efficiency.forecast": "交付預測看板",
  "menu.dashboard.efficiency.commit": "程式碼提交",
  "menu.dashboard.efficiency.commit.commitStatistics": "提交統計",
  "menu.dashboard.efficiency.commit.commitRecord": "提交記錄",
  "menu.dashboard.efficiency.commit.commitChart": "提交統計圖表",
  "menu.dashboard.efficiency.commit.sonar": "靜態掃描",
  "menu.dashboard.efficiency.commit.openSCA": "程式碼風險",
  "menu.dashboard.efficiency.analysis": "程式碼分析",
  "menu.dashboard.efficiency.analysis.front-endOxlint": "前端Oxlint",
  "menu.dashboard.efficiency.attendance": "工時資料",
  "menu.dashboard.efficiency.attendance.attendanceData": "考勤資料",
  "menu.dashboard.efficiency.attendance.workHourStatistics": "工時統計",
  "menu.dashboard.efficiency.attendance.workHourChart": "工時圖表",
  "menu.cmdb": "CMDB",
  "menu.cmdb.dns": "域名解析",
  "menu.cmdb.dnsRecord": "解析設定",
  "menu.cmdb.aliyun": "阿里雲",
  "menu.cmdb.aliyun.ecs": "ECS",
  "menu.cmdb.aliyun.rds": "RDS",
  "menu.cmdb.aliyun.polardb": "PolarDB",
  "menu.cmdb.aliyun.region": "地域",
  "menu.cmdb.aliyun.projectMeta": "資源後設資料",
  "menu.cmdb.aliyun.metricMetadata": "指標後設資料",
  "menu.itsm": "ITSM",
  "menu.itsm.myProcessedTickets": "我的處理",
  "menu.itsm.mySubmittedTickets": "我的提交",
  "menu.question": "問題看板",
  "menu.question.online": "線上問題池",
  "menu.question.record": "事故覆盤記錄",
  "menu.techManagement": "技術管理",
  "menu.techManagement.accidentReport": "生產事故報告",
  "menu.techManagement.goeReview": "COE覆盤記錄",
  "menu.techManagement.technicalDebt": "技術債務",
  "menu.techManagement.doc": "流程圖看板",
  "menu.techManagement.gocTimelineBoard": "Goc事件統一看板",
  "menu.tools": "Tools",
  "menu.tools.logCenter": "德國日誌中心",
  "menu.tools.notProd": "測試環境日誌",
  "menu.tools.webLog": "WEB日誌中心",
  "menu.tools.developLog": "Develop日誌中心",
  "menu.tools.iTopLog": "iTop日誌中心",
  "menu.tools.sls": "SLS",
  "menu.tools.arms": "ARMS鏈路分析",
  "menu.tools.clickVisual": "ClickVisual",
  "menu.tools.polarDB": "SlowSql",
  "menu.aiCoding": "AiCoding",
  "menu.approval": "審批",
  "menu.approval.list": "審批",
  "menu.approval.sqlOrder": "SQL工單",
  "menu.subscribe": "訂閱",
  "menu.settings": "設定",
  "menu.settings.label": "標籤管理",
  "menu.settings.status": "狀態資料",
  "menu.settings.statusType": "狀態管理",
  "menu.settings.rejectNode": "駁回節點管理",
  "menu.settings.template": "內容模版管理",
  "menu.settings.industry": "行業線管理",
  "menu.settings.service": "服務管理",
  "menu.settings.business": "業務領域",
  "menu.settings.workflow": "工作流管理",
  "menu.settings.approval": "審批管理",
  "menu.settings.metric": "效能指標管理",
  "menu.settings.systemVersion": "系統更新記錄",
  "menu.settings.likeCard": "點贊卡管理",
  "menu.slsDasbhoard": "可觀測平臺",
  "menu.slsDasbhoard.createOrderQps": "下單介面效能",
  "menu.slsDasbhoard.wirelessLog": "無線端日誌視覺化",
};
